import React, {
  ComponentType,
  FunctionComponent,
  lazy,
  Suspense,
  useMemo,
} from 'react';
import { currenciesData, CurrencyType } from '@monorepo/client-common';
import { Application, CryptoCurrency } from '@monorepo/types';
import { Avatar, AvatarProps } from '../../index';
import { CountryIcon } from '../country-icon';

import './currency-avatar.scss';

const UsdtIcon = lazy(() => import('./tether-usdt-logo.svg?react'));
const EthereumIcon = lazy(() => import('./ethereum-eth-logo.svg?react'));
const LtcIcon = lazy(() => import('./litecoin-ltc-logo.svg?react'));
const UsdcIcon = lazy(() => import('./usd-coin-usdc-logo.svg?react'));

const iconsMap: Array<{
  value: CryptoCurrency;
  icon: ComponentType;
}> = [
  { value: CryptoCurrency.USDT, icon: UsdtIcon },
  { value: CryptoCurrency.USDC, icon: UsdcIcon },
  { value: CryptoCurrency.ETH, icon: EthereumIcon },
  { value: CryptoCurrency.LTC, icon: LtcIcon },
];

type Props = AvatarProps & {
  type?: CurrencyType;
  name: string;
  project?: Application;
};

export const CurrencyAvatar: FunctionComponent<Props> = ({
  type = CurrencyType.Regular,
  name,
  project,
  ...avatarProps
}) => {
  if (type === CurrencyType.Crypto) {
    const cryptoIcon = useMemo(() => {
      const Icon = iconsMap.find((i) => i.value === name)?.icon;
      if (!Icon) {
        return null;
      }

      return (
        <Suspense>
          <Icon />
        </Suspense>
      );
    }, []);

    return <Avatar {...avatarProps} src={cryptoIcon} />;
  }

  const currencyIcon = currenciesData.find(
    (c) => c.countryCode === name || c.countryCodeExtended === name,
  );

  return (
    <div className="currency-avatar">
      <CountryIcon
        project={project}
        bordered={false}
        code={currencyIcon?.countryCode}
      />
    </div>
  );
};
